export default "__VITE_ASSET__BvCA7qRL__"